import { WIDTHS } from "./spacing";

/**
 * Canonical responsive breakpoints for CSS media queries, keyed to the same
 * `WIDTHS` values the `useScreenSize()` hook uses. Prefer these over hardcoded
 * pixel values so JS-driven (`isMobileScreen`/`isMediumScreen`) and CSS-driven
 * responsiveness stay in lockstep.
 *
 * These are plain strings, so they interpolate cleanly inside styled-components
 * template literals without any `css` typing friction:
 *
 *   const Box = styled.div`
 *     padding: ${SPACING.four}px;
 *     ${BREAKPOINTS.mobile} {
 *       padding: ${SPACING.two}px;
 *     }
 *   `;
 */
export const BREAKPOINTS = {
  /** ≤ 980px — mobile. Matches `useScreenSize().isMobileScreen`. */
  mobile: `@media (max-width: ${WIDTHS.S}px)`,
  /** ≤ 1280px — medium/tablet. Matches `useScreenSize().isMediumScreen`. */
  medium: `@media (max-width: ${WIDTHS.M}px)`,
  /** ≥ 981px — desktop and up. */
  desktopUp: `@media (min-width: ${WIDTHS.S + 1}px)`,
} as const;
